import de from './de.js';
import en from './en.js';
import da from './da.js';

export const DEFAULT_LANGUAGE = 'de';

const translations = { de, en, da };

/**
 * Builds the active text set: the built-in translations for `language`
 * (falling back to DEFAULT_LANGUAGE for unknown codes), with
 * `overrides[language]` merged on top, per key.
 *
 * @param {string} language
 * @param {object} [overrides] - per-language partial text overrides
 * @returns {{placeholder: string, searchPlaceholder: string, emptyText: string}}
 */
export function resolveTexts(language, overrides = {}) {
    const base = translations[language] ?? translations[DEFAULT_LANGUAGE];
    return { ...base, ...overrides[language] };
}
